export const content = `
<section>
  <h2>Introduction : Privacy by Design</h2>
  <p>
    La conformité n'est pas une case à cocher, c'est une contrainte d'architecture fondamentale. Chez Mesh Box, nous considérons que le respect du RGPD doit être codé dans l'ADN de l'application, conformément au principe de <strong>"Privacy by Design"</strong>.
  </p>
</section>

<hr>

<section>
  <h2>1. Logging : La Stratégie "Zero-Leak"</h2>
  <p>
    Il est inacceptable qu'un développeur puisse lire un email ou un mot de passe dans un dump d'erreur.
  </p>
  <ul class="content-list">
    <li>Utilisation de <strong>Pino</strong> avec <code>pino-redact</code> pour censurer les chemins sensibles (authorization, email, IBAN) à la source.</li>
    <li>Hachage déterministe (HMAC) pour la corrélation sans identification.</li>
  </ul>
</section>

<hr>

<section>
  <h2>2. Droit à l'oubli : Le Pattern "Crypto-Shredding"</h2>
  <p>
    Modifier des backups immuables pour supprimer un utilisateur est impossible. Nous utilisons le Crypto-Shredding.
  </p>
  <blockquote class="content-quote">
    Nous détruisons simplement la <strong>DEK</strong> (Data Encryption Key) de l'utilisateur. La donnée devient mathématiquement irrécupérable, rendant les backups conformes "by design".
  </blockquote>
</section>

<hr>

<section>
  <h2>3. Sécurité Angular : Cookies HttpOnly</h2>
  <p>
    L'abandon du localStorage au profit de Cookies <strong>HttpOnly</strong>, <strong>Secure</strong> et <strong>SameSite=Strict</strong> émis par un Backend For Frontend (BFF) neutralise les attaques XSS ciblant le vol de session.
  </p>
</section>

<hr>

<section>
  <h2>4. Chiffrement At Rest</h2>
  <p>
    Nous injectons des middlewares de chiffrement (AES-256-GCM) au niveau de l'ORM (Prisma/TypeORM) pour que la base de données ne voie jamais la donnée en clair.
  </p>
</section>

<hr>

<section>
  <h2>5. Consentement : Immutable Audit Log</h2>
  <p>
    Le consentement n'est pas un booléen (true/false). C'est un contrat juridique versionné qui doit être auditable.
  </p>
  <ul class="content-list">
    <li><strong>Le Pattern :</strong> Event Sourcing (Append-Only).</li>
    <li><strong>L'Implémentation :</strong>
      <ul class="content-list">
        <li>Nous ne faisons jamais d'<code>UPDATE</code> sur les préférences utilisateur. Chaque changement de consentement est un <code>INSERT</code> dans une table <code>ConsentLedger</code>.</li>
        <li>Ce log contient : l'ID utilisateur, le type de consentement, le timestamp, le hash de l'IP, et surtout l'ID de la version des CGU acceptée à cet instant précis.</li>
        <li>Cela permet de reconstruire l'historique complet en cas de contrôle CNIL.</li>
      </ul>
    </li>
  </ul>
  <p>
    Chez Mesh Box, nous transformons les contraintes légales en leviers de qualité architecturale.
  </p>
</section>

<div class="content-cta">
  <h3>Besoin d'un audit de conformité ?</h3>
  <p>Nos experts transforment vos contraintes légales en leviers de qualité architecturale.</p>
  <a href="/contact" class="button primary">Nous contacter</a>
</div>
`;
